module.exports = __webpack_public_path__ + "h5/img/di7.3e6f660c.png";